import { render } from "./LangSelector.vue?vue&type=template&id=6f8589c4&lang=pug"
import script from "./LangSelector.vue?vue&type=script&lang=js"
export * from "./LangSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__